import { Component, EventEmitter, Input, input, OnInit, Output } from '@angular/core';
import { ApiServiceService } from '../../../modules/services/api-service.service';
import { PaymentResponseDto } from '../../../modules/shared/models/general.modal';
import { ScriptLoaderService } from '../../../models/script-loader.service';
import alertify from 'alertifyjs';
import { HttpErrorResponse } from '@angular/common/http';

@Component({
  selector: 'app-payment-modal',
  standalone: true,
  imports: [],
  templateUrl: './payment-modal.component.html',
  styleUrl: './payment-modal.component.scss'
})
export class PaymentModalComponent implements OnInit {
  @Input() applicationId:string = '';
  @Output() close: EventEmitter<void> = new EventEmitter();
  
  constructor(private apiService: ApiServiceService, private scriptLoader: ScriptLoaderService) {}

  ngOnInit(): void {
    this.getPaymentDetails(this.applicationId);
  }


  getPaymentDetails(applicationId: string): void {
    const url = `/initiate-payment?applicationId=${applicationId}`;
    this.apiService.get(url).subscribe({
      next: (response: PaymentResponseDto) => {
        this.scriptLoader.loadScript('switch_inline').then(r => {
            this.checkout(response);
          });
      },
      error: (error) => {
        if (error instanceof HttpErrorResponse) {
          alertify.error(error.message);
        } else {
          alertify.error(JSON.stringify(error));
        }
        this.close.emit();
      },
    });
  }

  checkout(paymentDetails:PaymentResponseDto) {
    var paymentRequest = {
      merchant_code: paymentDetails.data.merchantCode,
      pay_item_id: paymentDetails.data.paymentId,
      pay_item_name: paymentDetails.data.description,
      txn_ref: paymentDetails.data.orderId,
      amount:Math.ceil((paymentDetails.data.amount*100 + Number.EPSILON) * 100)/100,
      currency: '566',
      cust_id: paymentDetails.data.invoiceNumber,
      site_redirect_url: window.location.origin,
      onComplete: this.paymentCallback,
      mode: paymentDetails.data.mode,
      cust_name: paymentDetails.data.payerName,
      cust_email: paymentDetails.data.payerEmail,
      cust_phone: paymentDetails.data.payerPhone,
    };
    if (paymentDetails.data.mode === "LIVE" && paymentDetails.data?.splitAccounts && Object.keys(paymentDetails.data.splitAccounts).length > 0) {
      paymentRequest['split_accounts'] = JSON.stringify(paymentDetails.data.splitAccounts);
    }
    (window as any).webpayCheckout(paymentRequest);
  }

  paymentCallback(response:any){
    if(response != null && parseFloat(response.amount) >0 ){
      sessionStorage.setItem('interResponse', JSON.stringify(response));
      setTimeout(()=>{
        window.open("/user/payment/return-back/" + response.txnref, "_self")
      }, 50);
    }
  }
}
